import React from "react";
import Image from "./Image";
import placeholderImage from '../assets/images/unavailable-image.jpg';

function CardItem({ name, code, picture, presence, url, minWeight, maxWeight, minPrice, maxPrice, sizes }) {

  const formatPrice = (price) => {
    if (price !== undefined && price !== null) {
      const strPrice = price.toString();
      if (strPrice.length === 4) {
        return (
          <>
            {strPrice[0]}
            <span className="space"></span>
            {strPrice.slice(1)}
          </>
        );
      } else if (strPrice.length === 5) {
        return (
          <>
            {strPrice.slice(0, 2)}
            <span className="space"></span>
            {strPrice.slice(2)}
          </>
        );
      } else if (strPrice.length === 6) {
          return (
            <>
              {strPrice.slice(0, 3)}
              <span className="space"></span>
              {strPrice.slice(3)}
            </>
          )
      } else {
        return strPrice;
      }
    }
  }

  const formatSizes = (sizes) => {
    if (sizes && Array.isArray(sizes) && sizes.length > 0) {
      return sizes.join(', ');
    }
    return '-';
  }

  return (
    <a className="product__card" href={url}>
      <Image
        src={picture}
        alt="My Image"
        fallbackSrc={placeholderImage} />
      <div className="product__info">
        <span className="product__price">{code}</span>
      </div>
      <div className="product__hover">
        <p className="product__description">{name}</p>
        <p className="product__description">Вага: {minWeight} - {maxWeight}</p>
        <p className="product__description">Розмір: {formatSizes(sizes)}</p>
        <p className="product__description">Ціна: {formatPrice(minPrice)} - {formatPrice(maxPrice)} грн</p>
        <p className="product__presence">{presence}</p>
      </div>
    </a>
  )
}

export default CardItem;
